import { Component, OnInit } from "@angular/core";
import { ContactComponent } from "./../contact/contact.component";
import { ModalService } from "./../../services/modal.service";
import { ModalComponent } from "./../../directives/modal/modal.component";

@Component({
  selector: "app-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
})
export class ContentComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }
}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/content/content.component.ts